import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import NewMain from '../headerone/newMain'
function AnimalHouseFacility() { 
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="Animal House Facility" /> 
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>MVN Animal House – Approved for Pharmacy Students</h3>
                                </div>
                                <div className='overview'>
                                    <h3>Overview</h3>
                                    <p>
                                    MVN University is pleased to announce that the <b>MVN Animal House has been officially approved for academic and research activities related to Pharmacy education.</b> This approval strengthens the university’s commitment to providing high-quality practical training and research exposure to Pharmacy students in accordance with regulatory and ethical standards.
                                </p>
                                <p>The Animal House is designed to support <b>teaching, training, and research requirements</b> of undergraduate and postgraduate Pharmacy programs, ensuring compliance with national guidelines for animal care and experimentation.</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>Purpose of the Animal House</h3>
                                </div>
                                <p><b>The MVN Animal House serves as a dedicated facility for:</b></p>
                                 <ul class="animal_key">
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Practical training of <b>Pharmacy students</b>
                                    </li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Conducting <b>preclinical and experimental studies</b>
                                    </li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Supporting <b>research projects and dissertations</b>
                                    </li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Enhancing hands-on learning in pharmacology and related disciplines</li>
                                </ul>
                                <p>This facility plays a vital role in bridging theoretical knowledge with real-world experimental understanding.</p>
                                <h3>Infrastructure and Facilities</h3>
                                <p><b>The Animal House at MVN University is developed with modern infrastructure and follows prescribed norms for animal welfare and safety. Key features include:</b></p>
                                <ul class="animal_key">
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Well-ventilated and hygienic animal housing areas</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Separate rooms for different categories of animals</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Controlled environmental conditions (temperature, lighting, and ventilation)</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Designated areas for experimentation and observation</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Proper waste disposal and sanitation systems</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Trained technical staff for animal care and maintenance</li>
                                 </ul>
                                 <p>All operations are carried out following ethical guidelines and standard operating procedures.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>Compliance and Ethical Standards</h3>
                                    <p><b>The MVN Animal House operates in strict adherence to:</b></p>
                                </div>
                                 <ul class="animal_key">
                                    <li><i class="fa fa-circle" aria-hidden="true"></i><b>Regulatory and ethical guidelines</b> prescribed by competent authorities</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Standard norms for animal care, handling, and experimentation</li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Institutional policies ensuring humane treatment of animals</li>
                                 </ul>
                                 <p>This ensures that students gain practical exposure while maintaining the highest ethical standards.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>Academic Benefits for Pharmacy Students</h3>
                                    <p><b>With the approval of the Animal House, Pharmacy students at MVN University will benefit from:</b></p>
                                </div>
                                 <ul class="animal_key">
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Enhanced <b>practical learning experience</b></li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Exposure to <b>experimental pharmacology</b></li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Improved understanding of <b>drug action and safety evaluation</b></li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Opportunities to participate in <b>research and innovation</b></li>
                                    <li><i class="fa fa-circle" aria-hidden="true"></i>Better preparation for <b>higher studies and professional careers</b></li>
                                 </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>MVN Animal House</h3>
                                    <ul class="animal_key">
                                        <li><i class="fa fa-circle" aria-hidden="true"></i>Exterior view of the Animal House</li>
                                            <li><i class="fa fa-circle" aria-hidden="true"></i>Interior laboratory and housing facilities</li>
                                            <li><i class="fa fa-circle" aria-hidden="true"></i>Animal care and maintenance areas</li>
                                            <li><i class="fa fa-circle" aria-hidden="true"></i>Practical training and observation spaces</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-1.jpg" alt="Img" />
                               
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-2.jpg" alt="Img" />
                                
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-3.jpg" alt="Img" />
                                
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-4.jpg" alt="Img" />
                                
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-5.jpg" alt="Img" />
                                
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                            <div className='animalimg'>
                                <img src="/assets/img/newanimal-img-6.jpg" alt="Img" />
                                
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title ">                                    
                                    <h3>Conclusion</h3>
                                    <p>The approval of the <b>MVN Animal House for Pharmacy students</b> marks a significant milestone in strengthening the academic and research ecosystem at MVN University. The university remains committed to providing state-of-the-art facilities, ethical research practices, and quality education to nurture future healthcare professionals.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </>
  )
}

export default AnimalHouseFacility